// removed by extract-text-webpack-plugin
module.exports = {"small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","hikeColor":"#58924D","runColor":"#0076C0","fitnessColor":"#375A92","rideColor":"#C53426","walkColor":"#885291","container":"container-3Sdxl","title":"title-1DYMu","subhead":"subhead-1DadN","note":"note-1iaUM","input":"input-y5omh","link":"link-1i3sH","select":"select-2KNWi","errorMessage":"errorMessage-blO0m","loadingModal":"loadingModal-1hJOV","loadingTitle":"loadingTitle-EqJ45","pageLoader":"pageLoader-NhcRr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/premium/_premium.css
// module id = 332
// module chunks = 1